import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Switch',
  setup(__props) {


const { control, inputModel, handleUpdate } = inject('input') as InputInjection

// Show append if sync, flag, or help is present
const ui = useUiStore()
const showAppend = computed(() => {
  return (ui.showSync && control.value.sync) || control.value.flag || control.value.help
})


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createBlock(_component_v_switch, _mergeProps({
    modelValue: _unref(inputModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null))
  }, _unref(control), {
    color: "primary",
    "onUpdate:modelValue": _unref(handleUpdate)
  }), _createSlots({ _: 2 }, [
    (_unref(showAppend))
      ? {
          name: "append",
          fn: _withCtx(() => [
            (_unref(control).help)
              ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                  key: 0,
                  "help-prompt": _unref(control).help
                }, null, 8, ["help-prompt"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "onUpdate:modelValue"]))
}
}

})